console.log('Hiii from js"');

const layers = {

    sky: document.querySelector(".sky"),
    clouds: document.querySelector(".clouds"),
    dragon: document.querySelector(".dragon"),
    mountains: document.querySelector(".mountains"),
    treesBack: document.querySelector(".treesback"),
    treesMid: document.querySelector(".treesmid"),
    treesFore: document.querySelector(".treesfore"),
    figure: document.querySelector(".figure"),
    grass: document.querySelector(".grass"),
    foreground: document.querySelector(".foreground")

};


document.addEventListener("scroll", e => {
    console.log("scroll event target:", e.target);
}, true);

const pageWrapper = document.querySelector(".page-wrapper");

pageWrapper.addEventListener("scroll", () => {
    const scroll = pageWrapper.scrollTop;

    layers.clouds.style.transform =
        `translateY(${scroll * -0.005}px)`;

    layers.mountains.style.transform =
        `translateY(${scroll * -0.007}px)`;

    layers.dragon.style.transform =
        `translateX(${scroll * 0.025}px) translateY(${scroll * -0.05}px)`;

    layers.treesBack.style.transform =
        `translateY(${scroll * -0.06}px)`;

    layers.treesMid.style.transform =
        `translateY(${scroll * -0.1}px)`;

    layers.treesFore.style.transform =
        `translateY(${scroll * -0.125}px)`;

    layers.figure.style.transform =
        `translateY(${scroll * -0.15}px)`;

    layers.grass.style.transform =
        `translateY(${scroll * -0.225}px)`;

    layers.foreground.style.transform =
        `translateY(${scroll * 0.05}px)`;

    console.log("scrolling", pageWrapper.scrollTop);
}, { passive: true });

/*


window.addEventListener("scroll", () => {

    const scroll = window.scrollY;

    layers.clouds.style.transform =
        `translateY(${scroll * -0.01}px)`;

    layers.mountains.style.transform =
        `translateY(${scroll * -0.015}px)`;

    layers.dragon.style.transform =
        `translateY(${scroll * -0.1}px)`;
    layers.dragon.style.transform =
        `translateX(${scroll * 0.05}px)`;

    layers.treesBack.style.transform =
        `translateY(${scroll * -0.12}px)`;

    layers.treesMid.style.transform =
        `translateY(${scroll * -0.2}px)`;

    layers.treesFore.style.transform =
        `translateY(${scroll * -0.25}px)`;

    layers.figure.style.transform =
        `translateY(${scroll * -0.3}px)`;

    layers.grass.style.transform =
        `translateY(${scroll * -0.45}px)`;

});

        */